import Immutable from 'immutable';
import React from 'react';

import Page from 'sharedreact/components/Page';
import PageContent from 'sharedreact/components/PageContent';
import Row from 'sharedreact/components/Row';
import WebApp from 'sharedreact/data/WebApp';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';
import { translate } from 'sharedreact/utils/LanguageSupport';

import LaunchCard from 'workspaces/launcher/components/clientapps/LaunchCard';
import HomeStatusbar from 'workspaces/launcher/components/HomeStatusbar';

type Props = {
  language: string,
  apps: Immutable.List<WebApp>
};

class WebAppsLauncherPage extends React.Component<Props> {
  renderWebAppLink (app: WebApp, index: number) {
    const {
      language
    } = this.props;

    const fullUrl: string = ConnectionSupport.createWebAppUrl(app.url);

    return (
      <Row useAlternateColor={index % 2 !== 0} key={'webapp_open' + index}>
        <LaunchCard id={'ae_card_launch_' + index}
          language={language}
          icon={app.icon}
          title={app.name}
          appId={app.id}
          description={translate('launcher.clientapps.' + app.id + '.description')}
          launchUrl={fullUrl}
        />
      </Row>
    );
  }

  override render (): React.ReactNode {
    const { apps } = this.props;

    return (
      <Page>
        <PageContent>
          {apps.map((app: WebApp, index: number) => this.renderWebAppLink(app, index))}
        </PageContent>
        <HomeStatusbar />
      </Page>
    );
  }
}

export default WebAppsLauncherPage;
